import { useGlobalOutreachProvider } from 'apps/outreach/contexts/global-outreach-context';
import TwilioCallButton from './twilio-call-button';

// Stable component identity so the button doesn't unmount/remount on every render of
// GlobalOutreachProvider (which happens on every notes keystroke). Remounting the
// button during a live call tears down audio elements and can drop the call.
const TwilioCallButtonConnected = (props) => {
  const { device, activeCall, startCall, endCall } = useGlobalOutreachProvider();
  return (
    <TwilioCallButton device={device} activeCall={activeCall} startCall={startCall} endCall={endCall} {...props} />
  );
};

export default TwilioCallButtonConnected;
